import { DialogActions, Button } from '@mui/material'
import { PickersActionBarProps } from '@mui/x-date-pickers-pro'
import dayjs, { Dayjs } from 'dayjs'
import { FC } from 'react'

/**
 * We only want to re-use this function on CustomDateTimePickerActionBar and LoadedDateTimePickerPopper - that is why it is not in a helpers function
 * @param value
 * @param minDateTime
 * @param maxDateTime
 * @returns
 */
export const isValueWithinRange = (
  value: Dayjs | null,
  minDateTime?: Dayjs | null,
  maxDateTime?: Dayjs | null
): boolean => {
  if (!value || (!minDateTime && !maxDateTime)) return true

  return (
    (minDateTime &&
      maxDateTime &&
      value.isBetween(minDateTime, maxDateTime, 'day', '[]')) ||
    (minDateTime && value.isSameOrAfter(minDateTime)) ||
    (maxDateTime && value.isSameOrBefore(maxDateTime)) ||
    (!minDateTime && !maxDateTime)
  )
}

export type CustomDateTimePickerActionBarProps = {
  minDateTime?: Dayjs | null
  maxDateTime?: Dayjs | null
  value?: Dayjs | null
  layout?: 'datetime' | 'date' | 'time'
  required?: boolean
} & PickersActionBarProps

const CustomDateTimePickerActionBar: FC<CustomDateTimePickerActionBarProps> = ({
  onAccept,
  onCancel,
  onSetToday,
  onClear,
  actions,
  minDateTime,
  maxDateTime,
  value,
  layout,
  required = false,
}) => {
  return (
    <DialogActions
      sx={{
        paddingBottom: '1rem',
        paddingTop: 0,
        ...(layout === 'time' && { justifyContent: 'space-between' }),
      }}
    >
      {actions?.find((a) => a === 'today') && (
        <Button
          variant="contained"
          onClick={onSetToday}
          disabled={
            !isValueWithinRange(
              value
                ? dayjs()
                    .set('hour', value.hour())
                    .set('minute', value.minute())
                    .set('second', 0)
                    .set('millisecond', 0)
                : null,
              minDateTime,
              maxDateTime
            )
          }
          sx={{ marginInlineEnd: 'auto' }}
        >
          Today
        </Button>
      )}
      {actions?.find((a) => a === 'clear') && (
        <Button variant="outlined" onClick={onClear}>
          Clear
        </Button>
      )}
      {actions?.find((a) => a === 'cancel') && (
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
      )}
      {actions?.find((a) => a === 'accept') && (
        <Button
          variant="contained"
          onClick={onAccept}
          disabled={
            (required && !value) ||
            (value && !isValueWithinRange(value, minDateTime, maxDateTime)) ||
            false
          }
        >
          Save
        </Button>
      )}
    </DialogActions>
  )
}

export default CustomDateTimePickerActionBar
